import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  dataDetail: null,
  dataVerifikasi: [],
  keyword: {
    listIssues: "",
    detailIssues: "",
    eskalasi: "",
    verifikasi: "",
    revisi: "",
    completed: "",
    allCompleted: ""
  },
  loading: false,
  sortConfig: {
    key: "tanggalDitemukan",
    direction: "DESC",
  },
  listCabang: [],
  listKRI: [],
  listHeader: [],
  listHeaderEskalasi: [],
  dataComment: [],
  dataCompleted: [],
  dataAllCompleted: [],
  dataHistory: [],
  dataLockComment: []
};

export const Issues = createSlice({
  name: "issues",
  initialState,
  reducers: {
    ChangeData: (state, action) => {
      state.data = action.payload;
    },
    ChangeDataDetail: (state, action) => {
      state.dataDetail = action.payload;
    },
    ChangeDataVerifikasi: (state, action) => {
      state.dataVerifikasi = action.payload;
    },
    ChangeKeyword: (state, action) => {
      const { menu, value } = action.payload;
      state.keyword[menu] = value;
    },
    ChangeLoading: (state, action) => {
      state.loading = action.payload;
    },
    ChangeSortConfig: (state, action) => {
      state.sortConfig = action.payload;
    },
    ChangeListCabang: (state, action) => {
      state.listCabang = action.payload;
    },
    ChangeListKRI: (state, action) => {
      state.listKRI = action.payload;
    },
    ChangeListHeader: (state, action) => {
      state.listHeader = action.payload;
    },
    ChangeListHeaderEskalasi: (state, action) => {
      state.listHeaderEskalasi = action.payload;
    },
    ChangeDataComment: (state, action) => {
      state.dataComment = action.payload;
    },
    ChangeDataCompleted: (state, action) => {
      state.dataCompleted = action.payload;
    },
    ChangeDataAllCompleted: (state, action) => {
      state.dataAllCompleted = action.payload;
    },
    ChangeDataHistory: (state, action) => {
      state.dataHistory = action.payload;
    },
    ChangeDataLockComment: (state, action) => {
      state.dataLockComment = action.payload;
    },
  },
});

export const {
  ChangeData,
  ChangeDataDetail,
  ChangeDataVerifikasi,
  ChangeKeyword,
  ChangeLoading,
  ChangeSortConfig,
  ChangeListCabang,
  ChangeListKRI,
  ChangeListHeader,
  ChangeListHeaderEskalasi,
  ChangeDataComment,
  ChangeDataCompleted,
  ChangeDataAllCompleted,
  ChangeDataHistory,
  ChangeDataLockComment
} = Issues.actions;

export default Issues.reducer;
